import { PointsStrategy, SpinWheelGamePrizeFragment } from '@ocx/graphql';
import { LoyaltyCurrencyChange } from '@ocx/feat-loyalty-currency';
import { OfferCard } from '@ocx/ui-offers';
import { useConfiguration } from '../../../../../modules/configuration/useConfiguration';

import { impressionTrackingCtxFromOffer } from '../../../../../modules/offers/tracking.types';

export const SpinWheelGamePrize = ({ award }: { award?: SpinWheelGamePrizeFragment['award'] }) => {
  const pointsStrategy = useConfiguration('loyaltyProgram.pointsStrategy');

  if (award?.__typename === 'AwardPoints' && pointsStrategy !== PointsStrategy.NotUsed) {
    return (
      <LoyaltyCurrencyChange
        points={award.points}
        iconSize="large"
        iconVariant="multiple"
        typographyProps={{ variant: 'h2', color: 'primary' }}
      />
    );
  }
  if (award?.__typename === 'AwardVouchers') {
    const {
      title,
      shortDescription = null,
      surgeonGeneralsWarning = null,
      imageUrl: imageSrc = null,
    } = award.voucheredOffer.marketingContents[0] || {};

    const vo = award.voucheredOffer;
    const trackingConfig = vo.trackingConfig
      ? {
          trackingId: vo.trackingConfig.trackingId,
          isActivityLogIncludedInAltriaDDM: vo.trackingConfig.isActivityLogIncludedInAltriaDDM,
        }
      : null;

    return (
      <OfferCard
        variant="sheet"
        impressionTrackingCtx={impressionTrackingCtxFromOffer({ id: vo.id, trackingConfig })}
        pointsDiff={null}
        progress={null}
        label={null}
        pointsStrategy={pointsStrategy}
        marketingContent={{
          title: title ?? '',
          imageSrc,
          shortDescription,
          surgeonGeneralsWarning,
        }}
      />
    );
  }
  return null;
};
